/// <reference path='../_all.ts' />

module tabs {
  'use strict';

  export class TabItem {
    public page: TabItemPart;
    public title: TabItemPart;
    public index : number;
    public navItem : navigation.AnchorNavItem;   
    public isActive : boolean;

    constructor(
      public pageId : string, 
      public routeId : number
    ) {
      this.isActive = false;
    }

    setActive(active : boolean) : void {
      this.page.setActiveFunction(active);
      this.title.setActiveFunction(active);
      this.isActive = active;
    }

  }

  export class TabItemPart {
    public setActiveFunction : (active : boolean) => void;

    constructor(
      public element : ng.IAugmentedJQuery
    ) { }
  }

}